/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["app-change-primary-contact .custom-error{display:block;color:red}app-change-primary-contact .left-margin{margin-left:10px;margin-bottom:5px}app-change-primary-contact .contact-min-width{min-width:250px!important}"];
export { styles as styles };
